module.exports = __webpack_public_path__ + "media/src/images/smtx__logo-6703cd4109f157a67832c5745e19bc2d.svg";